import { Skeleton, Typography } from 'antd';
import { CSSProperties, useState } from 'react';
import { BaseURLPreviewData, type URLPreviewData } from '../../../utils/urlPreview';

interface URLPreviewProps {
    url: string;
    urlPreviewPromise: Promise<URLPreviewData[]>;
}

const styles: Record<string, CSSProperties> = {
    container: {
        display: 'block',
        border: '1px solid #eee',
        borderRadius: '0.5rem',
        overflow: 'hidden'
    },
    image: {
        flex: '1',
        height: '250px',
        objectFit: 'cover'
    },
    content: {
        padding: '0.75rem'
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        columnGap: '0.5rem',
        fontWeight: 600
    },
    description: {
        display: 'block',
        maxHeight: '60px',
        overflow: 'auto',
        fontSize: '0.9rem'
    },
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #eee',
        borderRadius: '0.5rem',
        overflow: 'hidden'
    }
};

export default function URLPreview({ url, urlPreviewPromise }: URLPreviewProps) {
    const [loading, setLoading] = useState<boolean>(true);
    const [preview, setPreview] = useState<BaseURLPreviewData | undefined>();

    // TODO: seek for the validity of below implementation for promise
    try {
        urlPreviewPromise.then((previews) => {
            setPreview(previews?.[url]);
            setLoading(false);
        });
    } catch (e) {
        setLoading(false);
    }

    if (loading) {
        return (
            <div style={styles.loadingContainer}>
                <Skeleton.Image style={{ width: '100%', height: '150px' }} active={true} />
                <div style={styles.content}>
                    <Skeleton.Input size="small" active={true} />
                </div>
            </div>
        );
    }

    if (!preview?.data) {
        return null;
    }

    return (
        <div style={styles.container}>
            {preview.data.image && (
                <a href={url} target="_blank" rel="noreferrer" style={{ display: 'flex' }}>
                    <img src={preview.data.image} style={styles.image} />
                </a>
            )}
            <div style={styles.content}>
                <a href={url} target="_blank" rel="noreferrer" style={styles.title}>
                    {preview.data.favicon && (
                        <img src={preview.data.favicon} style={{ width: '1rem', height: '1rem' }} />
                    )}
                    <Typography.Text ellipsis>{preview.data.title}</Typography.Text>
                </a>
                {preview.data.description && (
                    <Typography.Text type="secondary" style={styles.description}>
                        {preview.data.description}
                    </Typography.Text>
                )}
            </div>
        </div>
    );
}
